/** Main authenticated content shell — padding from `--app-page-padding` in index.css */
export const appPageShellClassName = "app-page-shell";

/** Width + margin for header, main, footer — uses `--sidebar-offset` on `.app-layout` */
export const shellOffsetClassName = "shell-offset";

/** Institute name suffix in page titles (e.g. "Application - Govt. College…"). */
export const pageInstituteNameClassName = "font-normal text-primary";

/** Dash separator before institute name in page headings — always black. */
export const pageHeadingDashClassName = "font-normal text-ink";

/** Dashboard card section titles (Registered / Update Registered Institute). */
export const dashboardCardTitleClassName = "mb-3 text-lg font-semibold text-gray-900";

/** Emphasized status line under dashboard card title (e.g. certified institute note). */
export const dashboardCardHighlightNoteClassName =
	"mb-2 text-base font-semibold leading-relaxed text-muted";

/** Main authenticated page heading (h1) — employer portal: 22px, semibold, foreground. */
export const pageHeadingH1ClassName = "text-[22px] font-semibold text-foreground";

/** Main authenticated page heading (h2) — employer portal: text-xl, semibold, #161616. */
export const pageHeadingH2ClassName = "font-sans text-xl font-semibold leading-7 text-ink";

/** @deprecated Use pageHeadingH1ClassName for h1, pageHeadingH2ClassName for h2 */
export const pageHeadingClassName = pageHeadingH1ClassName;

/** @deprecated Use pageHeadingH2ClassName */
export const pageHeadingH3ClassName = pageHeadingH2ClassName;

/** Dashboard metric card — employer portal summary tiles. */
export const statCardShellClassName =
	"rounded-[14px] p-4 shadow-[0_2px_10px_rgba(15,47,58,0.06)] transition-shadow sm:p-5 lg:p-6";

export const statCardTitleClassName =
	"text-[10px] font-semibold uppercase leading-snug tracking-[0.03em] text-muted sm:text-[11px] lg:text-[13px]";

export const statCardValueClassName =
	"font-bold tabular-nums text-ink text-[2rem] leading-[1.2] sm:text-[2.1875rem] sm:leading-[1.5]";

export const segmentedControlTrackClassName =
	"inline-flex max-w-full gap-2 rounded-[5px] bg-tab-inactive p-1 bg-white";

export const segmentedControlTrackFullWidthClassName =
	"flex w-full max-w-full gap-2 rounded-[5px] bg-tab-inactive p-1 bg-white";

export const segmentedControlTabBaseClassName =
	"flex min-h-[36px] cursor-pointer items-center justify-center whitespace-nowrap rounded-[5px] px-6 py-2 font-sans text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tab-focus focus-visible:ring-offset-0";

export const segmentedControlTabStretchClassName = "min-w-0 flex-1 text-center";

export const segmentedControlTabActiveClassName =
	"bg-primary text-white shadow-tab-active hover:bg-primary-hover";

/** Inactive tab — text stays muted; grey fill on hover via .psda-segmented-tab-inactive in index.css */
export const segmentedControlTabInactiveClassName =
	"psda-segmented-tab-inactive bg-transparent text-muted";

export function getSegmentedControlTabClassName(isActive: boolean, stretch = false): string {
	return [
		segmentedControlTabBaseClassName,
		stretch ? segmentedControlTabStretchClassName : "",
		isActive ? segmentedControlTabActiveClassName : segmentedControlTabInactiveClassName,
	]
		.filter(Boolean)
		.join(" ");
}

/** Table pagination — employer portal Previous / page numbers / Next. */
export const paginationNavButtonClassName =
	"inline-flex items-center gap-1 rounded-[5px] border px-3 py-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tab-focus focus-visible:ring-offset-0";

export const paginationPageButtonClassName =
	"inline-flex h-10 w-10 items-center justify-center rounded-[5px] border text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tab-focus focus-visible:ring-offset-0";

export const paginationDisabledClassName =
	"cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400";

export const paginationInactiveClassName =
	"border-gray-300 bg-white text-gray-700 hover:bg-gray-50";

export const paginationActiveClassName = "border-primary bg-primary text-white";

export const paginationNextEnabledClassName =
	"border-primary bg-primary text-white hover:bg-primary-hover";
